<mat-expansion-panel
  id="filter-panel"
  data-testid="filter-panel"
  [expanded]="startExpanded">
  <mat-expansion-panel-header class="filter-header">
    <mat-panel-title>
      <mat-icon class="brand-icon">filter_alt</mat-icon>
      {{ "components.all-leads-list.filter" | translate }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div>
    <mat-checkbox (change)="onSortChange($event.checked)">
      <mat-label>
        {{ "components.all-leads-list.sort-by-distance" | translate }}
      </mat-label>
    </mat-checkbox>

  </div>
  <!-- Prio Filter with Clear Button-->
  <div class="filter-row">
    <mat-form-field class="filter-field">
      <mat-label>
        {{ "components.all-leads-list.table.priority" | translate }}
      </mat-label>
      <mat-select [value]="filterService.priority()" (selectionChange)="selectPriority($event.value)">
        <mat-option [value]="undefined"></mat-option>
        @for (priority of priorities; track priority) {
          <mat-option [value]="priority">
            {{ "enums.priority." + priority | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (filterService.priority() !== undefined) {
      <button
        mat-icon-button
        type="button"
        data-testid="clear-city-filter-button"
        class="clear-button"
        (click)="clearPriorityFilter()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Due Date Filter with Clear Button -->
  <div class="filter-row" data-testid="due-date-filter-row">
    <mat-form-field class="filter-field">
      <mat-label>
        {{ "components.all-leads-list.table.dueDate" | translate }}
      </mat-label>
      <input
        matInput
        id="due-date-filter-input"
        aria-label="Days to due date"
        type="number"
        min="0"
        step="1"
        [value]="filterService.daysToDueDate() ?? ''"
        (input)="selectDaysToDueDate($any($event.target).value)"
      />
    </mat-form-field>
    @if (filterService.daysToDueDate() !== undefined) {
      <button
        mat-icon-button
        type="button"
        data-testid="clear-due-date-filter-button"
        class="clear-button"
        (click)="clearDaysToDueDateFilter()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <div class="filter-row" data-testid="business-category-filter-row">
    <mat-form-field class="filter-field">
      <mat-label>
        {{ "components.all-leads-list.table.businessCategory" | translate }}
      </mat-label>
      <mat-select
        [value]="filterService.businessCategory()"
        (selectionChange)="selectBusinessCategory($event.value)"
      >
        <mat-option [value]="undefined"></mat-option>
        @for (category of filterService.businessCategoryOptions(); track category) {
          <mat-option [value]="category">
            {{ "enums.businessCategory." + category | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (filterService.businessCategory() !== undefined) {
      <button
        mat-icon-button
        type="button"
        data-testid="clear-business-category-filter-button"
        class="clear-button"
        (click)="clearBusinessCategoryFilter()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <div class="filter-row" data-testid="lead-type-filter-row">
    <mat-form-field class="filter-field">
      <mat-label>
        {{ "components.all-leads-list.table.leadType" | translate }}
      </mat-label>
      <mat-select
        multiple
        [value]="filterService.leadType()"
        (selectionChange)="selectLeadType($event.value)"
      >
        @for (leadType of filterService.leadTypeOptions(); track leadType) {
          <mat-option [value]="leadType">{{ leadType }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (filterService.leadType().length > 0) {
      <button
        mat-icon-button
        type="button"
        data-testid="clear-lead-type-filter-button"
        class="clear-button"
        (click)="clearLeadTypeFilter()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- City Filter with Clear Button -->
  <div class="filter-row" data-testid="city-filter-row">
    <mat-form-field class="filter-field">
      <mat-label>
        {{ "components.all-leads-list.table.city" | translate }}
      </mat-label>
      <mat-select
        multiple
        [value]="filterService.cityFilter()"
        (selectionChange)="selectCity($event.value)"
      >
        @for (city of filterService.cityOptions(); track city) {
          <mat-option [value]="city">{{ city | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (filterService.cityFilter().length > 0) {
      <button
        mat-icon-button
        type="button"
        data-testid="clear-city-filter-button"
        class="clear-button"
        (click)="clearCityFilter()"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- PostalCode Filter with Clear Button -->
  <div class="filter-row" data-testid="postalcode-filter-row">
    <mat-form-field class="filter-field">
      <mat-label>
        {{ "components.all-leads-list.input-postalcode" | translate }}
      </mat-label>
      <input matInput id="plz-prefix-filter-input" aria-label="Postal code prefix" type="tel" [formControl]="plzPrefixControl"/>
      @if (plzPrefixControl.invalid) {
        <mat-error>{{ errorMessage() | translate }}</mat-error>
      }
    </mat-form-field>
    @if (plzPrefixControl.value?.length ?? 0 > 0) {
      <button
        mat-icon-button
        type="button"
        data-testid="clear-postalcode-filter-button"
        class="clear-button"
        (click)="plzPrefixControl.setValue('')"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Street Filter with Clear Button -->
  @if (filterService.detailedFiltersActive()) {
    <div class="filter-row" data-testid="street-filter-row">
      <mat-form-field class="filter-field">
        <mat-label>
          {{ "components.all-leads-list.table.street" | translate }}
        </mat-label>
        <mat-select
          multiple
          [value]="filterService.streetFilter()"
          (selectionChange)="selectStreet($event.value)"
        >
          @for (street of filterService.streetOptions(); track street) {
            <mat-option [value]="street">{{ street | translate }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (filterService.streetFilter().length > 0) {
        <button
          mat-icon-button
          type="button"
          data-testid="clear-street-filter-button"
          class="clear-button"
          (click)="clearStreetFilter()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }

  <!-- District Filter with Clear Button -->
  @if (filterService.detailedFiltersActive()) {
    <div class="filter-row" data-testid="district-filter-row">
      <mat-form-field class="filter-field">
        <mat-label>
          {{ "components.all-leads-list.table.district" | translate }}
        </mat-label>
        <mat-select
          multiple
          [value]="filterService.districtFilter()"
          (selectionChange)="selectDistricts($event.value)"
        >
          @for (district of filterService.districtOptions(); track district) {
            <mat-option [value]="district">
              {{ district | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      @if (filterService.districtFilter().length > 0) {
        <button
          mat-icon-button
          type="button"
          data-testid="clear-district-filter-button"
          class="clear-button"
          (click)="clearDistrictFilter()"
        >
          <mat-icon>close</mat-icon>
        </button>
      }
    </div>
  }
</mat-expansion-panel>
